import React, { FunctionComponent, useMemo } from "react";
import { Image, useColorModeValue } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import StatsTable from "components/stats-table";
import OnOffStatusBadge from "scenes/site/components/on-off-status-badge";
import DisconnectPointStatus from "./DisconnectPointStatus"
import CircuitBreakerStatus from "./CircuitBreakerStatus"
import BessStatus from "./BessStatus"


interface IProps {
  data: any;
  uiVersion: string;
}


const ExternalCommandStatsTable: FunctionComponent<IProps> = ({ data, uiVersion }) => {
  const intl = useIntl();
  const lightIconUrl = useMemo(() => {
    switch (uiVersion) {
      case "opuncie": return "/images/svg/command-icon-opuncie-light.svg";
    }
  }, [uiVersion]);
  const darkIconUrl = useMemo(() => {
    switch (uiVersion) {
      case "opuncie": return "/images/svg/command-icon-opuncie-dark.svg";
    }
  }, [uiVersion]);

  return (
    <StatsTable
      mb={8}
      rows={[
        {
          label: intl.formatMessage({
            id: "command__external_command__aggregator",
            defaultMessage: "Aggregator",
          }),
          value: <Image src={useColorModeValue(lightIconUrl, darkIconUrl)} h={8} />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__control",
            defaultMessage: "Control",
          }),
          value: <OnOffStatusBadge state={data.control} />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__active_power",
            defaultMessage: "Active power",
          }),
          unit: "kW",
          decimals: 1,
          value: data.active_power,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__power_throttling",
            defaultMessage: "Power throttling",
          }),
          unit: "%",
          decimals: 1,
          value: data.power_throttling,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__circuit_breaker_state",
            defaultMessage: "Circuit breaker state",
          }),
          value: <CircuitBreakerStatus state={data.cb_state} />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__circuit_breaker_command",
            defaultMessage: "Circuit breaker command",
          }),
          value: <OnOffStatusBadge state={data.cb_command} colorOff="red" />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__circuit_breaker_command_ack",
            defaultMessage: "Circuit breaker command acknowledge",
          }),
          value: <OnOffStatusBadge state={data.cb_command_ack} colorOff="red" />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__bess_state",
            defaultMessage: "BESS state",
          }),
          value: <BessStatus state={data.bess_state} />,
        },
        {
          label: intl.formatMessage({
            id: "command__external_command__bp_state",
            defaultMessage: "Disconnection point state",
          }),
          value: <DisconnectPointStatus state={data.bp_state} />,
        },
      ]}
    />
  );
};

export default ExternalCommandStatsTable;
